import { render } from "./updateAddress.vue?vue&type=template&id=186f9588"
import script from "./updateAddress.vue?vue&type=script&lang=js"
export * from "./updateAddress.vue?vue&type=script&lang=js"

import "./updateAddress.vue?vue&type=style&index=0&id=186f9588&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__